var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[[_c('Nav')],_c('router-view'),[_c('Footer')],_c('el-backtop',{attrs:{"right":20}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }